import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoatempotraveller() {



const cardData = {


keyword: "Pune to Goa Tempo Traveller",

headingDescription:
    "Ruturaj Enterprises offers comfortable and reliable Pune to Goa Tempo Traveller services for families, friends, corporate groups, and large travel parties. With AC, luxury, 13-seater, 17-seater, and 20-seater options, travelers can choose a vehicle according to group size and journey requirements. Whether you need a one-way transfer, round trip, weekend getaway, family vacation, or extended Goa tour, a well-equipped Tempo Traveller makes the long journey from Pune to Goa more convenient and enjoyable.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa's most popular coastal destinations, known for its lively atmosphere, water activities, beachside restaurants, and vibrant evening scene. Groups traveling from Pune can comfortably include Baga in their Goa itinerary and enjoy convenient road access with a spacious Tempo Traveller."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach attracts visitors with its broad sandy shoreline, water sports, shopping areas, and numerous cafes and restaurants. A group Tempo Traveller from Pune makes it easier for families and friends to travel together while carrying luggage and beach essentials without needing multiple cars."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus in Old Goa is an important historical and religious attraction famous for its beautiful architecture and heritage significance. Travelers visiting Goa with family or a group can conveniently add this destination to their sightseeing plan while enjoying comfortable transportation throughout the day."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a historic Portuguese-era fort overlooking the Arabian Sea and is among Goa's most recognizable attractions. Its scenic surroundings and coastal views make it an excellent stop for travelers arriving from Pune, particularly groups looking to combine sightseeing with photography and exploration."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is a spectacular natural attraction located in Goa's forested region and is especially popular during the monsoon season. Travelers planning an extended Goa trip can include this destination in their itinerary and use the Tempo Traveller for comfortable group transportation between major points."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach offers a distinctive combination of rocky coastline, relaxed beach surroundings, cafes, and a lively local atmosphere. It is a popular choice for friends and younger travel groups visiting Goa, while a spacious Tempo Traveller provides a convenient way to keep everyone together during the trip."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is a comparatively relaxed coastal destination with pleasant surroundings, beachside dining, and easy access to several North Goa attractions. Families and larger groups traveling from Pune can use a dedicated Tempo Traveller to move comfortably between Candolim and nearby sightseeing locations."
    },
    {
        title: "Panaji",
        description:
            "Panaji, the capital city of Goa, features colorful streets, Portuguese-influenced architecture, riverside views, churches, markets, and cultural attractions. A Pune to Goa group journey can include Panaji as a convenient sightseeing stop while the same Traveller continues to serve the group throughout the itinerary."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is well known for its scenic shoreline, calm surroundings, palm-lined views, and relaxed holiday atmosphere. Groups choosing a longer Goa vacation can comfortably travel toward South Goa in a spacious Tempo Traveller and enjoy the flexibility of planning multiple destinations together."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort provides panoramic views of the surrounding coastline and is a favorite location for photography and sunset experiences. It can be included in a North Goa sightseeing schedule along with nearby beaches, making it suitable for families, friends, and weekend groups traveling from Pune."
    }
],

services: [
    {
        name: "Pune to Goa Tempo Traveller on Rent",
        description:
            "Ruturaj Enterprises provides Pune to Goa Tempo Traveller on Rent services for groups looking for a practical and comfortable alternative to traveling in multiple cars. Spacious seating, suitable luggage capacity, and group-friendly travel arrangements make the journey convenient for families, friends, and organized travel parties."
    },
    {
        name: "Pune to Goa Tempo Traveller Hire",
        description:
            "Pune to Goa Tempo Traveller Hire is suitable for travelers who want a dedicated vehicle for the complete journey and Goa sightseeing schedule. Vehicle options can be selected according to group size, while the spacious interior allows passengers to travel together without splitting the group across several smaller vehicles."
    },
    {
        name: "Pune to Goa Tempo Traveller Booking",
        description:
            "Pune to Goa Tempo Traveller Booking allows travelers to arrange their group transportation in advance for holidays, family vacations, weekend plans, and special tours. Ruturaj Enterprises helps groups select a suitable Traveller according to seating requirements, trip duration, travel plan, and preferred journey arrangement."
    },
    {
        name: "AC Tempo Traveller Pune to Goa",
        description:
            "AC Tempo Traveller Pune to Goa is a comfortable choice for the long road journey, especially when traveling with children, senior citizens, or a large family group. Air-conditioned interiors provide a more pleasant environment during the trip, while generous seating space helps passengers relax throughout the route."
    },
    {
        name: "Luxury Tempo Traveller Pune to Goa",
        description:
            "Luxury Tempo Traveller Pune to Goa services are designed for travelers who prefer an upgraded group travel experience with comfortable interiors and a more premium feel. It works well for corporate groups, friends, families, wedding-related travel, and holiday parties seeking convenient transportation from Pune to Goa."
    },
    {
        name: "13 Seater Tempo Traveller Pune to Goa",
        description:
            "13 Seater Tempo Traveller Pune to Goa is an excellent option for medium-sized families, friend groups, and small tour parties. The seating arrangement provides enough room for passengers to stay together while traveling between Pune and Goa, making it easier to coordinate stops, luggage, and sightseeing plans."
    },
    {
        name: "17 Seater Tempo Traveller Pune to Goa",
        description:
            "17 Seater Tempo Traveller Pune to Goa is suitable for larger groups that want one dedicated vehicle for their complete journey. It provides a practical balance between passenger capacity and group comfort, making it useful for family vacations, college groups, corporate outings, and organized Goa tours."
    },
    {
        name: "20 Seater Tempo Traveller Pune to Goa",
        description:
            "20 Seater Tempo Traveller Pune to Goa is designed for bigger travel groups that require greater passenger capacity without dividing everyone among several cars. It is particularly useful for group tours, extended families, event transportation, and vacation parties planning a shared road journey from Pune."
    },
    {
        name: "Tempo Traveller for Goa Trip from Pune",
        description:
            "Tempo Traveller for Goa Trip from Pune gives travelers the flexibility to plan their road journey according to their preferred Goa destinations and duration. Families and friends can travel together, carry their holiday luggage more conveniently, and coordinate beach visits, sightseeing stops, and hotel transfers with a dedicated group vehicle."
    },
    {
        name: "Pune Goa Group Travel Tempo Traveller",
        description:
            "Pune Goa Group Travel Tempo Traveller is a convenient solution when multiple travelers want to stay together throughout the journey. Instead of arranging separate cars, the group can choose a suitable seating capacity and enjoy a coordinated road trip with convenient transportation for both travel and local Goa movement."
    },
    {
        name: "Pune Goa Family Trip Tempo Traveller",
        description:
            "Pune Goa Family Trip Tempo Traveller is suitable for families traveling with children, parents, relatives, and extended family members. The spacious seating arrangement helps everyone remain together, while the dedicated vehicle provides flexibility for luggage, sightseeing breaks, hotel transfers, and family-friendly Goa destinations."
    },
    {
        name: "Pune to Goa Round Trip Tempo Traveller",
        description:
            "Pune to Goa Round Trip Tempo Traveller is ideal for travelers who want transportation for both the onward and return journeys. This arrangement can simplify holiday planning by keeping group transportation organized from Pune to Goa and back, while also supporting local sightseeing during the planned trip."
    },
    {
        name: "Pune to Goa One Way Tempo Traveller",
        description:
            "Pune to Goa One Way Tempo Traveller works well for travelers who need a dedicated group vehicle only for the journey toward Goa. It can be useful for families relocating temporarily, groups beginning a Goa vacation, or travelers who have arranged separate transportation for their return journey."
    },
    {
        name: "Tempo Traveller for Goa Outstation Trip",
        description:
            "Tempo Traveller for Goa Outstation Trip provides a practical travel arrangement for groups planning a longer road journey from Pune. With multiple seating capacities available, travelers can select a vehicle that matches their group size and enjoy a more organized experience for the intercity journey and Goa sightseeing."
    },
    {
        name: "Affordable Tempo Traveller Pune to Goa",
        description:
            "Affordable Tempo Traveller Pune to Goa is intended for groups seeking comfortable shared transportation while keeping travel expenses practical. Choosing one suitable vehicle can reduce the need for multiple cars and help the group manage transportation more efficiently across the Pune to Goa journey."
    },
    {
        name: "Pune Goa AC Traveller Rental",
        description:
            "Pune Goa AC Traveller Rental offers an air-conditioned group travel option for travelers who value comfort during the long-distance road journey. It is suitable for families, friends, corporate teams, and tour groups that need a dedicated vehicle for reaching Goa and moving between planned destinations."
    },
    {
        name: "Pune Goa Luxury Traveller Hire",
        description:
            "Pune Goa Luxury Traveller Hire is a suitable choice for groups looking for a more premium travel setup for their Goa vacation. The service can be considered for corporate outings, family celebrations, special occasions, and leisure tours where comfortable group transportation is an important part of the overall travel experience."
    },
    {
        name: "Tempo Traveller for Goa Tour Pune",
        description:
            "Tempo Traveller for Goa Tour Pune supports organized holiday itineraries covering beaches, forts, churches, markets, waterfalls, and other popular attractions. A dedicated Traveller gives the group greater flexibility to coordinate sightseeing schedules and travel between different parts of Goa without arranging separate vehicles."
    },
    {
        name: "Tempo Traveller for Goa Family Vacation",
        description:
            "Tempo Traveller for Goa Family Vacation is designed for families who want to enjoy their holiday journey together from Pune. Comfortable seating and suitable vehicle capacity make it easier to accommodate relatives, children, luggage, and planned sightseeing requirements while maintaining a convenient family travel experience."
    },
    {
        name: "Tempo Traveller for Goa Group Tour",
        description:
            "Tempo Traveller for Goa Group Tour is well suited to friends, office teams, college groups, extended families, and organized tour parties. A single group vehicle keeps the travelers together and simplifies transportation planning for the Pune journey, Goa sightseeing, hotel transfers, and return travel."
    },
    {
        name: "Pune to Goa Weekend Trip Traveller",
        description:
            "Pune to Goa Weekend Trip Traveller is a practical option for short holiday plans where travelers want to make the most of limited time. Groups can travel together from Pune, reach their selected Goa destinations, visit multiple attractions, and return according to their planned weekend schedule."
    },
    {
        name: "Pune Goa Traveller Rental Service",
        description:
            "Pune Goa Traveller Rental Service caters to different group transportation requirements, from family holidays and weekend trips to corporate outings and extended sightseeing programs. Ruturaj Enterprises provides vehicle options based on group size and trip requirements so travelers can plan a convenient Pune to Goa journey."
    }
],

tableData: [
    ["Pune to Goa Tempo Traveller on Rent", "Pune to Goa Tempo Traveller Hire"],
    ["Pune to Goa Tempo Traveller Booking", "AC Tempo Traveller Pune to Goa"],
    ["Luxury Tempo Traveller Pune to Goa", "13 Seater Tempo Traveller Pune to Goa"],
    ["17 Seater Tempo Traveller Pune to Goa", "20 Seater Tempo Traveller Pune to Goa"],
    ["Tempo Traveller for Goa Trip from Pune", "Pune Goa Group Travel Tempo Traveller"],
    ["Pune Goa Family Trip Tempo Traveller", "Pune to Goa Round Trip Tempo Traveller"],
    ["Pune to Goa One Way Tempo Traveller", "Tempo Traveller for Goa Outstation Trip"],
    ["Affordable Tempo Traveller Pune to Goa", "Pune Goa AC Traveller Rental"],
    ["Pune Goa Luxury Traveller Hire", "Tempo Traveller for Goa Tour Pune"],
    ["Tempo Traveller for Goa Family Vacation", "Tempo Traveller for Goa Group Tour"],
    ["Pune to Goa Weekend Trip Traveller", "Pune Goa Traveller Rental Service"]
],

whychoose: [
    {
        WhyChooseheading: "Comfortable Long-Distance Group Travel",
        WhyChoosedescription:
            "The Pune to Goa route involves a long road journey, making comfortable seating and a spacious interior important for an enjoyable trip. Ruturaj Enterprises offers suitable Tempo Traveller options that allow families and groups to travel together while avoiding the inconvenience of managing several separate cars."
    },
    {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription:
            "Different groups have different passenger requirements, so a single vehicle size may not work for every trip. Options such as 13-seater, 17-seater, and 20-seater Travellers make it easier to select transportation according to the number of travelers and the amount of luggage being carried."
    },
    {
        WhyChooseheading: "Suitable for Family Holidays",
        WhyChoosedescription:
            "A Goa family vacation becomes easier to coordinate when parents, children, relatives, and other family members can remain in one vehicle. The group can manage luggage and sightseeing plans together while enjoying a more organized journey from Pune to Goa."
    },
    {
        WhyChooseheading: "Ideal for Friends and Group Tours",
        WhyChoosedescription:
            "Friends and larger travel groups can avoid splitting into multiple cars by choosing a Traveller with sufficient seating capacity. This keeps communication simple during the road trip and makes it easier to coordinate beach visits, meals, sightseeing stops, hotel transfers, and other activities."
    },
    {
        WhyChooseheading: "AC Travel for the Pune-Goa Route",
        WhyChoosedescription:
            "For a lengthy intercity journey, an air-conditioned vehicle can provide a more comfortable environment, particularly during warmer weather. AC Tempo Traveller options are useful for families, senior travelers, children, and groups who prefer a pleasant interior throughout their journey."
    },
    {
        WhyChooseheading: "Convenient One-Way and Round Trips",
        WhyChoosedescription:
            "Travel plans differ from group to group, which is why both one-way and round-trip arrangements can be useful. Travelers can select the transportation pattern that fits their holiday schedule, whether they are heading to Goa for a short stay or planning a complete return journey to Pune."
    },
    {
        WhyChooseheading: "Flexible Goa Sightseeing Plans",
        WhyChoosedescription:
            "A dedicated Tempo Traveller gives groups greater flexibility to organize sightseeing across North Goa, South Goa, Panaji, heritage attractions, beaches, forts, and other destinations. Instead of coordinating several cars, everyone can follow the same planned itinerary with a common group vehicle."
    },
    {
        WhyChooseheading: "Practical Choice for Different Occasions",
        WhyChoosedescription:
            "The service can accommodate a wide range of travel purposes, including weekend getaways, family vacations, corporate outings, group tours, celebrations, and extended Goa holidays. Ruturaj Enterprises focuses on matching the vehicle arrangement with the group's passenger count and overall travel requirements."
    }
]


};



const faqData = [
{
question: "Why choose a Tempo Traveller for Pune to Goa travel?",
answer: "A Tempo Traveller makes the Pune to Goa journey convenient for groups who prefer to stay together throughout the trip. Ruturaj Enterprises offers spacious group transportation suitable for families, friends, corporate teams, and organized holiday tours."
},
{
question: "Can I rent a Tempo Traveller from Pune to Goa for a family vacation?",
answer: "Families can hire a Tempo Traveller when planning a Goa holiday with relatives and children. Traveling in one vehicle provides comfortable group seating, convenient luggage arrangements, and easier coordination throughout the journey."
},
{
question: "Is a Tempo Traveller suitable for a Pune to Goa group trip?",
answer: "For larger groups, a Tempo Traveller can be a practical alternative to using several cars. Passengers can travel together, share the same itinerary, and enjoy a more coordinated road trip from Pune to Goa."
},
{
question: "Can friends book a Tempo Traveller from Pune to Goa?",
answer: "Friend groups can arrange a Tempo Traveller through Ruturaj Enterprises for Goa vacations, weekend plans, beach holidays, and longer trips. Having one group vehicle makes it easier to travel together between destinations."
},
{
question: "Can I book a Tempo Traveller for a multi-day Goa trip?",
answer: "Multi-day Goa tours can be planned with a Tempo Traveller according to the group's travel schedule. The vehicle can support transportation between Pune, Goa, hotels, sightseeing locations, beaches, restaurants, and other planned stops."
},
{
question: "Does Ruturaj Enterprises provide a driver for Pune to Goa Tempo Traveller?",
answer: "Driver-assisted Tempo Traveller arrangements are available for group journeys, allowing passengers to relax during the road trip while the driver takes care of driving and route navigation. This can be especially useful for a long-distance Pune to Goa journey."
},
{
question: "Can we carry luggage in the Tempo Traveller for a Goa trip?",
answer: "Passengers can carry their travel bags and other belongings, with luggage capacity depending on the selected Tempo Traveller and number of travelers. Ruturaj Enterprises can help select a suitable vehicle based on your group's requirements."
},
{
question: "Can a corporate group hire a Tempo Traveller from Pune to Goa?",
answer: "Corporate teams can use a Tempo Traveller for business outings, employee trips, conferences, team-building programs, and company holidays in Goa. Group transportation helps keep employees together and simplifies travel coordination."
},
{
question: "Can the Tempo Traveller be used for Goa sightseeing after reaching from Pune?",
answer: "Yes, groups can plan local Goa sightseeing as part of their travel itinerary. Depending on the selected plan, the vehicle can be used for visiting beaches, markets, churches, forts, viewpoints, and other attractions during the trip."
},
{
question: "How can I book a Pune to Goa Tempo Traveller with Ruturaj Enterprises?",
answer: "To arrange your Pune to Goa Tempo Traveller, provide Ruturaj Enterprises with your pickup location, travel date, passenger count, trip duration, and preferred vehicle requirements. The suitable group travel option can then be planned for your journey."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Aditya Shinde",
feedback:
"Our group booked a Tempo Traveller from Pune to Goa through Ruturaj Enterprises for a holiday with friends. The vehicle was spacious enough for everyone and our luggage, while traveling together made the long road journey much more enjoyable.",
rating: 5
},
{
id: 2,
name: "Miss. Pooja Sawant",
feedback:
"We arranged a family Goa trip with Ruturaj Enterprises and were happy with the Tempo Traveller service. The journey was comfortable, the group could stay together, and the vehicle worked well for both the Pune travel and our sightseeing plans.",
rating: 5
}
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Tempo Traveller",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-goa-tempo-traveller.webp",
  "description":
    "Pune to Goa Tempo Traveller from Ruturaj Enterprises is a convenient group travel solution for families, friends, corporate teams, wedding groups and tourists planning a road trip from Pune to Goa. Pune to Goa Tempo Traveller on Rent is suitable for one-way journeys, round trips, weekend holidays, extended vacations, group tours and customized Goa travel itineraries. Pune to Goa Tempo Traveller Hire provides an easy way for larger groups to travel together with professional driver assistance, avoiding the need to arrange multiple cars for the same journey. Pune to Goa Tempo Traveller Booking can be planned according to the group size, preferred departure time, pickup location and return schedule. AC Tempo Traveller Pune to Goa is suitable for a comfortable long-distance road journey, while Luxury Tempo Traveller Pune to Goa offers a more premium travel experience for families, corporate groups, destination wedding guests and special trips. 13 Seater Tempo Traveller Pune to Goa and 17 Seater Tempo Traveller Pune to Goa provide practical seating choices for small and larger groups traveling together. The Pune to Goa route is popular for beach holidays, family vacations, friends' trips, corporate outings, destination weddings, college groups and weekend road trips. Travelers can plan sightseeing across North Goa and South Goa, including destinations and attractions around Calangute, Baga, Anjuna, Vagator, Candolim, Panaji, Dona Paula, Old Goa, Morjim, Colva, Benaulim, Palolem and other popular coastal locations. A customized itinerary can also include stops around Kolhapur, Belgaum, Amboli, Sawantwadi and other places along the route. Pune to Goa Tempo Traveller Round Trip is convenient for groups that want flexible local sightseeing and a scheduled return journey to Pune. Pickup arrangements can be coordinated from Kothrud, Baner, Aundh, Wakad, Hinjewadi, Pimpri, Chinchwad, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Talegaon, Moshi, Bhosari and nearby Pune areas. The service is suitable for family holidays, group vacations, corporate travel, wedding guest transportation, tourist groups, college trips and multi-day Goa tours. Ruturaj Enterprises provides flexible Tempo Traveller rental arrangements with experienced drivers for Pune to Goa road travel, sightseeing and group transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-goa-tempo-traveller"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Goa Tempo Traveller | Pune to Goa Tempo Traveller on Rent | +91 9763381382</title>

  <meta
    name="description"
    content="Pune to Goa Tempo Traveller for family trips, group tours, weekend holidays, corporate travel, weddings and sightseeing. Hire AC, Luxury, 13 Seater and 17 Seater Tempo Travellers with driver."
  />

  <meta
    name="keywords"
    content="Pune to Goa Tempo Traveller on Rent, Pune to Goa Tempo Traveller Hire, Pune to Goa Tempo Traveller Booking, AC Tempo Traveller Pune to Goa, Luxury Tempo Traveller Pune to Goa, 13 Seater Tempo Traveller Pune to Goa, 17 Seater Tempo Traveller Pune to Goa, Pune to Goa Tempo Traveller, Pune to Goa Tempo Traveller Rental, Pune to Goa Tempo Traveller Service, Pune to Goa Tempo Traveller with Driver, Pune to Goa Traveller Hire, Pune to Goa Traveller Booking, Pune to Goa Traveller Rental, Pune to Goa AC Traveller, Pune to Goa Luxury Traveller, Pune to Goa 13 Seater Traveller, Pune to Goa 17 Seater Traveller, Pune to Goa Tempo Traveller One Way, Pune to Goa Tempo Traveller Round Trip, Pune to Goa Tempo Traveller Same Day, Pune to Goa Tempo Traveller Outstation, Pune to Goa Outstation Tempo Traveller, Pune to Goa Tempo Traveller for Family Trip, Pune to Goa Tempo Traveller for Group Travel, Pune to Goa Tempo Traveller for Friends Trip, Pune to Goa Tempo Traveller for Corporate Trip, Pune to Goa Tempo Traveller for Corporate Events, Pune to Goa Tempo Traveller for Wedding, Pune to Goa Tempo Traveller for Wedding Guest, Pune to Goa Tempo Traveller for Destination Wedding, Pune to Goa Tempo Traveller for Tourist Group, Pune to Goa Tempo Traveller for College Trip, Pune to Goa Tempo Traveller for Student Group, Pune to Goa Tempo Traveller for Family Vacation, Pune to Goa Tempo Traveller for Holiday Trip, Pune to Goa Tempo Traveller for Weekend Trip, Pune to Goa Tempo Traveller for Beach Trip, Pune to Goa Tempo Traveller for Road Trip, Pune to Goa Tempo Traveller for Goa Tour, Pune to Goa Tempo Traveller for Goa Sightseeing, Pune to Goa Tempo Traveller Tour Package, Pune to Goa Group Tour Package, Pune to Goa Family Tour Package, Pune to Goa Weekend Tour Package, Pune to Goa Holiday Tour Package, Pune to Goa Sightseeing Package, Pune to Goa Travel Service, Pune to Goa Group Transportation, Pune to Goa Family Transportation, Pune to Goa Tourist Transportation, Pune to Goa Corporate Transportation, Pune to Goa Wedding Transportation, Pune to Goa Private Tempo Traveller, Pune to Goa Private Traveller, Pune to Goa Tempo Traveller Rental with Driver, Pune to Goa Tempo Traveller Hire with Driver, Pune to Goa Tempo Traveller Booking with Driver, Affordable Tempo Traveller Pune to Goa, Budget Tempo Traveller Pune to Goa, Comfortable Tempo Traveller Pune to Goa, Premium Tempo Traveller Pune to Goa, Luxury Tempo Traveller Hire Pune to Goa, Luxury Tempo Traveller Rental Pune to Goa, AC Tempo Traveller Hire Pune to Goa, AC Tempo Traveller Rental Pune to Goa, Non AC Tempo Traveller Pune to Goa, Non AC Tempo Traveller Hire Pune to Goa, Non AC Tempo Traveller Rental Pune to Goa, Pune to Goa Tempo Traveller Full Day, Pune to Goa Tempo Traveller Half Day, Pune to Goa Tempo Traveller Hourly Rental, Pune to Goa Tempo Traveller Multi Day, Pune to Goa Tempo Traveller Weekend Rental, Pune to Goa Tempo Traveller Holiday Rental, Pune to Goa Tempo Traveller Vacation Rental, Pune to Goa Tempo Traveller for North Goa, Pune to Goa Tempo Traveller for South Goa, Pune to Goa Tempo Traveller Sightseeing, Pune to North Goa Tempo Traveller, Pune to South Goa Tempo Traveller, Pune to Panaji Tempo Traveller, Pune to Calangute Tempo Traveller, Pune to Baga Tempo Traveller, Pune to Anjuna Tempo Traveller, Pune to Vagator Tempo Traveller, Pune to Candolim Tempo Traveller, Pune to Dona Paula Tempo Traveller, Pune to Old Goa Tempo Traveller, Pune to Morjim Tempo Traveller, Pune to Colva Tempo Traveller, Pune to Benaulim Tempo Traveller, Pune to Palolem Tempo Traveller, Pune to Goa Beach Tour Tempo Traveller, Pune to Goa Family Vacation Tempo Traveller, Pune to Goa Friends Trip Tempo Traveller, Pune to Goa Corporate Outing Tempo Traveller, Pune to Goa Wedding Guest Transportation, Pune to Goa Group Travel Tempo Traveller, Pune to Goa Tourist Tempo Traveller, Pune to Goa Road Trip Tempo Traveller, Pune to Goa Weekend Getaway Tempo Traveller, Pune to Goa Long Distance Tempo Traveller, Pune to Goa Holiday Tempo Traveller, Pune to Goa Airport Transfer Tempo Traveller, Pune to Goa Hotel Transfer Tempo Traveller, Pune to Goa Resort Transfer Tempo Traveller, Pune to Goa Railway Station Transfer Tempo Traveller, Pune to Goa Hotel Pickup Tempo Traveller, Pune to Goa Guest Pickup Tempo Traveller, Pune to Goa 13 Seater Tempo Traveller Rental, Pune to Goa 17 Seater Tempo Traveller Rental, Pune to Goa 13 Seater Tempo Traveller Hire, Pune to Goa 17 Seater Tempo Traveller Hire, Pune to Goa 13 Seater Tempo Traveller Booking, Pune to Goa 17 Seater Tempo Traveller Booking, Pune to Goa AC 13 Seater Tempo Traveller, Pune to Goa AC 17 Seater Tempo Traveller, Pune to Goa Luxury 13 Seater Tempo Traveller, Pune to Goa Luxury 17 Seater Tempo Traveller, Pune to Goa Tempo Traveller from Kothrud, Pune to Goa Tempo Traveller from Baner, Pune to Goa Tempo Traveller from Aundh, Pune to Goa Tempo Traveller from Wakad, Pune to Goa Tempo Traveller from Hinjewadi, Pune to Goa Tempo Traveller from Pimpri, Pune to Goa Tempo Traveller from Chinchwad, Pune to Goa Tempo Traveller from Viman Nagar, Pune to Goa Tempo Traveller from Kharadi, Pune to Goa Tempo Traveller from Hadapsar, Pune to Goa Tempo Traveller from Kondhwa, Pune to Goa Tempo Traveller from Katraj, Pune to Goa Tempo Traveller from Shivajinagar, Pune to Goa Tempo Traveller from Swargate, Pune to Goa Tempo Traveller from Talegaon, Pune to Goa Tempo Traveller from Moshi, Pune to Goa Tempo Traveller from Bhosari, Pune to Goa Tempo Traveller via Kolhapur, Pune to Goa Tempo Traveller via Belgaum, Pune to Goa Tempo Traveller via Amboli, Pune to Goa Tempo Traveller via Sawantwadi, Pune to Goa Tempo Traveller for Beach Holiday, Pune to Goa Tempo Traveller for Group Vacation, Pune to Goa Tempo Traveller for Family Holiday, Pune to Goa Tempo Traveller for Corporate Travel, Pune to Goa Tempo Traveller for Wedding Travel, Pune to Goa Tempo Traveller for Multi Day Tour"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoatempotraveller;